import { type UserToken, queryKeys as jwtQueryKeys } from "@sunrise/jwt";
import type { Nullable } from "@sunrise/utils";

export const queryKeys = {
  user: (at: Nullable<UserToken>) =>
    [...jwtQueryKeys.userToken(at), "user"] as const,
};
